import { UnitStateV2 } from '@eppendorf/vnls-device-service-utils';
import { HasChildren } from '@eppendorf/vnls-react-components';

interface UnlessOfflineProps extends HasChildren {
  activityState?: UnitStateV2;
  noFallback?: boolean;
}

export function UnlessOffline({
  activityState,
  children,
  noFallback = false,
}: UnlessOfflineProps) {
  const toReturn = <div>{noFallback ? '' : '-'}</div>;

  if (activityState) {
    if (activityState === UnitStateV2.Offline) {
      return toReturn;
    }
  }

  return children;
}
